import { useMemo } from 'react';
import { computeCurviness, CURVINESS_COLORS } from '../../utils/curviness';
import './CurvinessBadge.css';

/**
 * Shows a route's curviness as a coloured label with chili peppers.
 * Renders nothing if geometry is too short to score.
 *
 * variant: 'chip' (pill with background) | 'inline' (compact, for stat rows)
 */
export function CurvinessBadge({ geometry, variant = 'chip' }) {
  const c = useMemo(() => computeCurviness(geometry), [geometry]);
  if (!c) return null;

  const color = CURVINESS_COLORS[c.level];
  const peppers = '🌶'.repeat(c.chilis);
  const title = `Curviness: ${c.label} (${Math.round(c.degPerKm)}°/km)`;

  if (variant === 'inline') {
    return (
      <span className="curviness curviness--inline" style={{ color }} title={title}>
        <span className="curviness__dot" style={{ background: color }} />
        {c.label}{peppers && <span className="curviness__peppers">{peppers}</span>}
      </span>
    );
  }

  return (
    <span
      className="curviness curviness--chip"
      style={{ color, background: `${color}1a` }}
      title={title}
    >
      {c.chilis > 0 && <span className="curviness__peppers">{peppers}</span>}
      {c.label}
      <span className="curviness__score">{Math.round(c.degPerKm)}°/km</span>
    </span>
  );
}
